import type {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import type { IPublicClientApplication } from '@azure/msal-browser';
import {
  BrowserCacheLocation,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '../../environments/environment';

function loggerCallback(logLevel: LogLevel, message: string): void {
  if (logLevel <= LogLevel.Info) {
    console.log('[MSAL]', message);
  }
}

export function MSALInstanceFactory(): IPublicClientApplication {
  const { azureAd } = environment;
  return new PublicClientApplication({
    auth: {
      clientId: azureAd.clientId,
      authority: azureAd.authority,
      redirectUri: azureAd.redirectUri,
      postLogoutRedirectUri: azureAd.postLogoutRedirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // URL absoluta de la API: con MSAL v5 el matching es estricto; una ruta relativa
  // se resuelve contra el origen de la app (ej. localhost:4200) y no coincide con la API (ej. localhost:44302).
  const apiBaseUrl = environment.urlAPI.replace(/\/?$/, '/');
  protectedResourceMap.set(apiBaseUrl, [environment.azureAd.apiScope]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    strictMatching: false, // legacy: asegura que coincidan URLs que empiecen por apiBaseUrl
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [environment.azureAd.apiScope],
    },
    loginFailedRoute: '/login-failed',
  };
}

export const MSAL_PROVIDERS = [
  { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
  { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
  { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
] as const;
